/* SteamMaster Cube, CRO-productpagina (2026-09-27). Vanilla, defer, geen dependencies.
 *
 * Meten: add_to_cart, begin_checkout en view_item komen al uit Shopify Customer Events / web pixels
 * en worden hier bewust NIET opnieuw verstuurd (geen dubbele conversies). Dit script stuurt alleen
 * UI-interacties, als één namespaced event naar de bestaande GTM-dataLayer (GTM-5DLV7BQ7) en naar
 * Shopify.analytics.publish voor custom pixels:
 *   event: 'pdp_interaction', pdp: 'steammaster-cube', interaction: <naam>, detail: <tekst>
 * Interacties: gallery_swipe, gallery_nav, video_play, faq_open, inbox_open, specs_open,
 * main_atc_click, sticky_atc_click, final_atc_click, trustpilot_click, choice_other_click,
 * risk_link_click, section_view.
 * Zonder GTM-trigger op 'pdp_interaction' doen deze events niets.
 */
(function () {
  'use strict';
  var pdpEl = document.querySelector('[data-cube-pdp]');
  var PDP = pdpEl ? pdpEl.getAttribute('data-cube-pdp') : 'steammaster-cube';
  var once = {};
  // Seizoensvariant (bijv. autumn_2026) meesturen, zodat Control en Herfstactie later te vergelijken zijn
  var variantEl = document.querySelector('[data-cube-variant]');
  var VARIANT = variantEl ? variantEl.getAttribute('data-cube-variant') : 'control';
  try { (window.dataLayer = window.dataLayer || []).push({ pdp_variant: VARIANT }); } catch (e) {}
  var viaSticky = false;

  function track(interaction, detail, onlyOnce) {
    var key = interaction + '|' + (detail || '');
    if (onlyOnce && once[key]) return;
    once[key] = true;
    var payload = { event: 'pdp_interaction', pdp: PDP, pdp_variant: VARIANT, interaction: interaction, detail: detail || '' };
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('pdp_interaction', { pdp: PDP, pdp_variant: VARIANT, interaction: interaction, detail: detail || '' });
      }
    } catch (e) {}
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Galerij ---------- */
  document.querySelectorAll('[data-cube-gallery]').forEach(function (gal) {
    var track_ = gal.querySelector('.cube-slides');
    if (!track_) return;
    var slides = Array.prototype.slice.call(track_.querySelectorAll(':scope > .cube-slide'));
    var cur = gal.querySelector('[data-cube-current]');
    var media = gal.closest('.cube-hero__media');
    var thumbs = media ? Array.prototype.slice.call(media.querySelectorAll('[data-cube-goto]')) : [];
    var active = 0;
    var userMoved = false;

    function setActive(i) {
      if (i === active) return;
      active = i;
      if (cur) cur.textContent = String(i + 1);
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      // Een video die uit beeld schuift pauzeren
      slides.forEach(function (s, j) {
        if (j !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
      if (userMoved) track('gallery_swipe', 'slide_' + (i + 1), true);
    }
    if (thumbs[0]) { thumbs[0].classList.add('is-active'); thumbs[0].setAttribute('aria-current', 'true'); }

    function go(i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      userMoved = true;
      track_.scrollTo({ left: track_.clientWidth * n, behavior: reduce ? 'auto' : 'smooth' });
    }

    if ('IntersectionObserver' in window) {
      var ratios = slides.map(function () { return 0; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios[slides.indexOf(e.target)] = e.intersectionRatio; });
        var best = 0;
        for (var k = 1; k < ratios.length; k++) if (ratios[k] > ratios[best]) best = k;
        if (ratios[best] > 0.5) setActive(best);
      }, { root: track_, threshold: [0, 0.5, 0.75, 1] });
      slides.forEach(function (s) { io.observe(s); });
    }
    track_.addEventListener('touchstart', function () { userMoved = true; }, { passive: true });
    track_.addEventListener('wheel', function () { userMoved = true; }, { passive: true });

    var prev = gal.querySelector('[data-cube-prev]');
    var next = gal.querySelector('[data-cube-next]');
    if (prev) prev.addEventListener('click', function () { track('gallery_nav', 'prev', true); go(active - 1); });
    if (next) next.addEventListener('click', function () { track('gallery_nav', 'next', true); go(active + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { track('gallery_nav', 'thumb', true); go(parseInt(t.getAttribute('data-cube-goto'), 10) || 0); });
    });
    track_.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
    });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      track_.scrollLeft = track_.clientWidth * active;
    }, { passive: true });
  });

  /* ---------- Video in de galerij: pas laden na een tik ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cube-video]');
    if (!btn) return;
    var url = btn.getAttribute('data-cube-video');
    if (!url) return;
    var v = document.createElement('video');
    v.src = url;
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    var slide = btn.parentNode;
    slide.replaceChild(v, btn);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    track('video_play', 'gallery', true);
  });
  // Bestaande videosectie (sophitech-videos) meten, zonder die sectie te wijzigen
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.sm-video-card[data-video-url]');
    if (card) track('video_play', (card.getAttribute('aria-label') || '').replace('Speel video af: ', ''), true);
  });

  /* ---------- details/summary meten ---------- */
  document.querySelectorAll('[data-cube-faq]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) track('faq_open', d.getAttribute('data-cube-faq'), true); });
  });
  document.querySelectorAll('[data-cube-track-toggle]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) track(d.getAttribute('data-cube-track-toggle'), '', true); });
  });
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-cube-track]');
    if (!el) return;
    // Een klik op de sticky balk wordt doorgegeven aan de hoofdknop: die telt dan niet nog eens als main_atc_click
    if (viaSticky && el.getAttribute('data-cube-track') === 'main_atc_click') { viaSticky = false; return; }
    track(el.getAttribute('data-cube-track'), '', false);
  });

  /* ---------- Secties in beeld (scrolldiepte per bouwsteen) ---------- */
  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { track('section_view', e.target.getAttribute('data-cube-section'), true); seen.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-cube-section]').forEach(function (s) { seen.observe(s); });
  }

  /* ---------- Sticky koopbalk (mobiel) ----------
   * Nooit twee koopknoppen tegelijk in beeld.
   */
  var sticky = document.querySelector('[data-cube-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var btn = sticky.querySelector('[data-cube-sticky-btn]');
    var main = document.getElementById(btn && btn.getAttribute('data-target'));
    var fin = document.querySelector('[data-cube-final]');
    var mainVisible = true, finalVisible = false;
    document.body.classList.add('cube-has-sticky');

    function update() {
      // Zichtbaar zodra de hoofdknop niet in beeld is (ook bij binnenkomst: dan staan prijs en knop
      // direct in de eerste viewport) en verborgen zolang de hoofdknop of de slot-CTA in beeld is.
      var on = !mainVisible && !finalVisible;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('cube-sticky-on', on);
    }
    if (main) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { mainVisible = e.isIntersecting; });
        update();
      }).observe(main);
    }
    if (fin) {
      new IntersectionObserver(function (en) { en.forEach(function (e) { finalVisible = e.isIntersecting; }); update(); }).observe(fin);
    }
    if (btn && main) {
      btn.addEventListener('click', function () {
        track('sticky_atc_click', '', false);
        viaSticky = true;
        main.click(); // zelfde product-form, dus zelfde cart drawer en zelfde Shopify-events
      });
    }
  }
})();
